<template>
    <tr>
        <td class="rowBlock" colspan="10">{{ title }}</td>
    </tr>
</template>

<script>
  export default {
    props: {
      title: String,
    },
    name: 'ShopperTableSubHeader'
  }
</script>

<style scoped>

</style>